<template>
    <div id="sign_in">
        <div>
            <el-card>
                <div class="el-card-button">
                    <el-button type="primary" size="small" @click="addRecharge">添加VIP特权</el-button>
                </div>
                <div>
                    <el-table
                            :data="tableData"
                            border
                            style="width: 100%">
                        <el-table-column
                                prop="list_order"
                                label="排序">
                        </el-table-column>
                        <el-table-column
                                prop="title"
                                label="标题">
                        </el-table-column>
                        <el-table-column
                                prop="content"
                                label="图标">
                            <template slot-scope="scope">
                                <img :src="scope.row.image" alt="" width="30">
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="title"
                                label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status==0">禁用</span>
                                <span v-if="scope.row.status==1">启用</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                width="150"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button type="warning" plain size="small" @click="edit(scope.row.id)">修改</el-button>
                                <el-button type="danger" plain size="small" @click="getareaDelete(scope.row.id)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </el-card>
            <!--            新增或编辑-->
            <el-dialog :title="fromTitle"
                       :width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'90%':'50%'"
                       :visible.sync="visible">

                <el-form ref="form"
                         :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'70px':'150px'"
                         size="small">
                    <el-form-item label="标题"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                        <el-input v-model="form.title"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="图标">
                        <el-upload
                                class="avatar-uploader"
                                action="upDataUrl"
                                :show-file-list="false"
                                :http-request="myUpload"
                                :before-upload="beforeAvatarUpload">
                            <img v-if="form.image" :src="form.image" class="avatar" alt="">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="排序"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                        <el-input v-model="form.list_order"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''"></el-input>
                    </el-form-item>
                    <el-form-item label="是否启用"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                        <el-select v-model="form.status" placeholder="请选择启用状态"
                                   :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {uploadimg} from '../../utils/common'

    export default {
        name: "sign_in",
        data() {
            return {
                form: {
                    title: '',
                    list_order: '',
                    image: '',
                    status: ''
                },
                tableData: [],
                visible: false,
                fromTitle: '',
                id: '',

            }
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                this.$axios.post('admin/vip_privilege/index',).then((res) => {
                    let arr = res.data.list;
                    this.tableData = arr;
                });
            },
            dialogClose() {
                this.visible = false
            },
            addRecharge() {
                this.fromTitle = '新增';
                this.form = {
                    title: '',
                    list_order: '',
                    image: '',
                    status: ''
                };
                this.id = '';
                this.visible = true;
            },
            edit(id) {
                this.fromTitle = '修改';
                this.id = id;
                this.$axios.get('admin/vip_privilege/' + this.id).then((res) => {
                    this.visible = true;
                    this.form = res.data;
                });
            },
            // 删除
            getareaDelete(id) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.del("admin/vip_privilege/" + id)
                        .then(res => {
                            this.$message.success('删除成功!');
                            this.getData();
                        })
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
            },
            dialogAffirm() {
                if (this.id !== '') {
                    this.$axios.put('admin/vip_privilege/' + this.id, this.form).then((res) => {
                        this.$message.success('成功');
                        this.getData();
                        this.visible = false
                    });
                } else {
                    this.$axios.post('admin/vip_privilege', this.form).then((res) => {
                        this.$message.success('成功');
                        this.getData();
                        this.visible = false
                    });
                }
            },
            beforeAvatarUpload(file) {
                var suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
                let arr = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'PDF']
                if (arr.indexOf(suffix) === -1) {
                    this.$message.error('上传图片格式有误');
                    return false
                }
            },
            // 上传文件
            myUpload(content) {
                uploadimg(content).then(res => {
                    this.form.image = res;
                })
            },
        }
    }
</script>

<style scoped>

</style>